import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../customs/skeleton/main";

const Main = lazy(() => import("../../components/settings/licenseRenewalExamsSetup/main"));

const LicenseRenewalExamsSetup = () => {
  return (
        <Suspense fallback={<PageSkeleton />}>
          <Main />
        </Suspense>
  );
};

export default LicenseRenewalExamsSetup;

